"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUrlParam = getUrlParam;
exports.monitorWindowStatus = monitorWindowStatus;
exports.removeParameters = removeParameters;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _jusdaPublicmethod = require("@jusda-tools/jusda-publicmethod");
var _languageControlPanel = require("@jusda-tools/language-control-panel");
var _index = _interopRequireDefault(require("../locales/index.js"));
var cookieTools = new _jusdaPublicmethod.CookieTools();
Array.prototype.flat = function value() {
  var depth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  if (typeof this.reduce === 'function') {
    return this.reduce(function (flat, toFlatten) {
      return flat.concat(Array.isArray(toFlatten) && depth > 1 ? toFlatten.flat(depth - 1) : toFlatten);
    }, []);
  }
  return Array.prototype.reduce.call(this, function (flat, toFlatten) {
    return flat.concat(Array.isArray(toFlatten) && depth > 1 ? toFlatten.flat(depth - 1) : toFlatten);
  }, []);
};
function getUrlParam(href, name) {
  var decodeHref = decodeURIComponent(href);
  var value = "";
  decodeHref.split("?").map(function (item) {
    return item.split("&");
  }).flat().filter(function (item) {
    return item.includes("=");
  }).reverse().forEach(function (item) {
    var _item$split = item.split("="),
      _item$split2 = (0, _slicedToArray2["default"])(_item$split, 2),
      k = _item$split2[0],
      v = _item$split2[1];
    if (k === name) {
      value = v;
    }
  });
  return value;
}

// 原生浏览器窗户是否被激活方法
function monitorWindowStatus() {
  var locales = _index["default"].get((0, _languageControlPanel.currentLanguage)() === "zh-CN" ? "zh-CN" : "en-US");
  // 不同浏览器 hidden 名称
  var hiddenProperty = 'hidden' in document ? 'hidden' : 'webkitHidden' in document ? 'webkitHidden' : 'mozHidden' in document ? 'mozHidden' : null;
  // 不同浏览器的事件名
  var visibilityChangeEvent = hiddenProperty.replace(/hidden/i, 'visibilitychange');
  var onVisibilityChange = function onVisibilityChange() {
    if (!document[hiddenProperty]) {
      var userIdentityId_Tab = sessionStorage.getItem(_jusdaPublicmethod.UserIdentityId_Tab);
      var userIdentityId_Newest = cookieTools.get(_jusdaPublicmethod.UserIdentityId_Newest);
      // 当前页面的身份ID和全局存储的身份ID不相同
      if (userIdentityId_Tab && userIdentityId_Newest && userIdentityId_Tab !== userIdentityId_Newest) {
        var html = document.getElementById('userIdentityerror');
        if (!html) {
          var dom = document.createElement("div");
          dom.id = 'userIdentityerror';
          dom.className = 'userIdentityerror';
          dom.innerHTML = "<div style=\"position:fixed;inset:0;z-index:1001;height:100%;background-color: #00000073\"></div>" + "<div tabindex=\"-1\" style=\"z-index: 1001;position: fixed;inset: 0;overflow:auto;outline: 0;\">" + "<div style=\"max-width: 500px; height:135px; top:100px;position: relative;margin: 0 auto;background-color:#fff\">" + "<div style=\"padding: 20px\">".concat(locales.userIdentityError, "</div>") + "<div style=\"position:absolute; bottom: 0; right: 0\">" + "<button class=\"btn_reload\"" + "type=\"button\" onclick=\"document.getElementById('userIdentityerror').remove(); window.location.reload();\">".concat(locales.reload, "</button>") + "</div>" + "</div>" + "</div>";
          document.getElementsByTagName('body')[0].appendChild(dom);
          var style = document.createElement('style');
          style.type = 'text/css';
          style.innerHTML = ".userIdentityerror .btn_reload{" + "margin:12px;" + "cursor:pointer;" + "border-radius:3px;" + "padding:4px 15px;" + "border: 1px solid #d9d9d9;" + "border-color: #ffc500;" + "background: #ffc500;" + "}" + ".userIdentityerror .btn_reload:hover{" + "border-color: #ffd429;" + "background: #ffd429;" + "}";
          document.getElementsByTagName('head').item(0).appendChild(style);
        }
      }
    }
  };
  document.addEventListener(visibilityChangeEvent, onVisibilityChange); // 添加元素事件句柄
}

// 删除url上的参数
function removeParameters(url, paramsToRemove) {
  try {
    // 创建一个 URL 对象
    var urlObj = new URL(url);

    // 处理 URL 的查询参数部分
    var searchParams = new URLSearchParams(urlObj.search);
    paramsToRemove.forEach(function (param) {
      return searchParams["delete"](param);
    });
    urlObj.search = searchParams.toString();

    // 处理 URL 的 hash 部分
    var hash = urlObj.hash;
    if (hash.includes('?')) {
      var _hash$split = hash.split('?'),
        _hash$split2 = (0, _slicedToArray2["default"])(_hash$split, 2),
        hashPrefix = _hash$split2[0],
        hashQuery = _hash$split2[1];
      var hashParams = new URLSearchParams(hashQuery);
      paramsToRemove.forEach(function (param) {
        return hashParams["delete"](param);
      });
      urlObj.hash = "".concat(hashPrefix, "?").concat(hashParams.toString());
    }
    return urlObj.toString();
  } catch (error) {
    console.error('An error occurred:', error.message);
    return url; // 返回原始 URL 以防止错误中断程序
  }
}